import { LIST_EVENT, LIST_EVENT_ALERT } from "../actions/types";

const initialState = {
  events: {
    count: 0,
    rows: [],
  },
  alerts: {
    count: 0,
    rows: [],
  },
};

const events = (state = initialState, action) => {
  switch (action.type) {
    case LIST_EVENT:
      return {
        ...state,
        events: action.payload,
      };
    case LIST_EVENT_ALERT:
      return {
        ...state,
        alerts: action.payload,
      };
    default:
      return state;
  }
};

export default events;
